import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-10-small', 'Number10Small', [["path",{"d":"M8 8h1v8"}],["path",{"d":"M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0"}]]);